import { configureStore, Middleware } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

import {
  signInModalReducer,
  deviceTypeReducer,
  toursReducer,
  utilsReducer,
  authStateReducer,
  joinBetaDataReducer,
  providersReducer,
} from './slices';

const logger = createLogger({
  collapsed: true,
}) as Middleware;

export const store = configureStore({
  reducer: {
    signInModal: signInModalReducer,
    deviceType: deviceTypeReducer,
    tours: toursReducer,
    utilsStore: utilsReducer,
    authState: authStateReducer,
    joinBetaData: joinBetaDataReducer,
    providers: providersReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(logger),
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
